// Sentra - Questionnaire (CZ) - "O tobě" + "Hledám partnera"
// AI vypočítá kompatibilitu jako vzájemný fit mezi profily a očekáváními.

export const QUESTIONNAIRE = [
  // ========= O TOBĚ =========
  {
    key: "values",
    title: "Moje hodnoty",
    subtitle: "Co je pro tebe v životě nejdůležitější",
    icon: "💎",
    group: "Já",
    questions: [
      { id: "top_value", label: "Co je pro tebe v životě nejdůležitější?",
        options: [["family","Rodina"],["love","Láska"],["career","Kariéra"],["freedom","Svoboda"],["growth","Osobní růst"],["faith","Víra/spiritualita"]] },
      { id: "ambition", label: "Jak vysoké máš ambice?",
        options: [["high","Vysoké – chci dosáhnout hodně"],["balanced","Vyvážené"],["chill","Spíš v klidu žít"]] },
      { id: "faith", label: "Víra a spiritualita pro tebe znamenají...",
        options: [["important","Důležitou součást života"],["spiritual","Spirituální, ne náboženská"],["none","Neřeším"]] },
      { id: "politics", label: "Politika a společenské dění:",
        options: [["engaged","Aktivně mě zajímá"],["aware","Sleduji"],["avoid","Vyhýbám se"]] },
    ],
  },
  {
    key: "lifestyle",
    title: "Můj životní styl",
    subtitle: "Jak žiješ teď",
    icon: "🌿",
    group: "Já",
    questions: [
      { id: "energy", label: "Jsi spíš...",
        options: [["introvert","Introvert – nabíjím se v klidu"],["ambivert","Něco mezi"],["extrovert","Extrovert – mezi lidmi"]] },
      { id: "social", label: "Jak často chodíš mezi lidi / na akce?",
        options: [["often","Často"],["sometimes","Občas"],["rare","Zřídka"]] },
      { id: "sport", label: "Sport a pohyb:",
        options: [["daily","Denně"],["regular","Pravidelně"],["sometimes","Občas"],["rare","Zřídka"]] },
      { id: "alcohol", label: "Alkohol:",
        options: [["never","Nepiji"],["rare","Zřídka"],["social","Společensky"],["often","Často"]] },
      { id: "smoking", label: "Kouření:",
        options: [["no","Ne"],["sometimes","Občas"],["yes","Pravidelně"]] },
      { id: "pets", label: "Domácí mazlíčci:",
        options: [["have","Mám"],["love","Miluji, chci"],["ok","Nevadí"],["no","Ne"]] },
    ],
  },
  {
    key: "relationship",
    title: "Můj přístup ke vztahu",
    subtitle: "Jak miluji a komunikuji",
    icon: "💞",
    group: "Já",
    questions: [
      { id: "love_language", label: "Jak nejvíc projevuješ lásku?",
        options: [["words","Slova ocenění"],["time","Společný čas"],["gifts","Pozornosti / dárky"],["acts","Skutky služby"],["touch","Doteky a blízkost"]] },
      { id: "conflict", label: "Když je konflikt, ty...",
        options: [["talk","Hned to řeším"],["cool","Potřebuji čas a klid"],["avoid","Mám tendenci uhýbat"]] },
      { id: "communication", label: "Jak často chceš komunikovat s partnerem během dne?",
        options: [["constant","Skoro pořád"],["regular","Pravidelně"],["space","S prostorem"]] },
      { id: "type", label: "Jaký vztah hledáš?",
        options: [["serious","Vážný / dlouhodobý"],["open","Otevřený k vývoji"],["casual","Bez závazků"]] },
    ],
  },
  {
    key: "family_finance",
    title: "Rodina, děti a finance",
    subtitle: "Plány do budoucna",
    icon: "👶",
    group: "Já",
    questions: [
      { id: "children", label: "Děti:",
        options: [["have","Mám dítě"],["have_want_more","Mám a chci další"],["want","Chci"],["maybe","Nejsem si jistá"],["no","Nechci"]] },
      { id: "when", label: "Kdy chceš mít děti (pokud chceš)?",
        options: [["1-2","Do 2 let"],["3-5","Za 3–5 let"],["later","Později"],["na","Neřeším"]] },
      { id: "finance_sharing", label: "Jak řešit společné finance?",
        options: [["50_50","50/50"],["fair","Spravedlivě dle příjmů"],["one","Jeden hlavně živí"],["separate","Striktně oddělené"]] },
      { id: "saving", label: "Postoj k penězům:",
        options: [["saver","Šetřím a investuji"],["balanced","Vyváženě"],["enjoy","Užívám si teď"]] },
    ],
  },

  // ========= HLEDÁM PARTNERA =========
  {
    key: "partner_personality",
    title: "Osobnost partnera",
    subtitle: "Kdo k tobě sedí",
    icon: "✨",
    group: "Hledám",
    questions: [
      { id: "want_energy", label: "Jakou energii hledáš u partnera?",
        options: [["introvert","Klidnější introvert"],["ambivert","Vyvážený typ"],["extrovert","Společenský extrovert"],["any","Nezáleží"]] },
      { id: "humor", label: "Smysl pro humor je pro tebe...",
        options: [["must","Naprosto klíčový"],["nice","Hezký bonus"],["secondary","Druhořadý"]] },
      { id: "intelligence", label: "Intelektuální propojení:",
        options: [["high","Musíme si rozumět hluboce"],["medium","Hezké, ne nutné"],["low","Důležitější je srdce"]] },
      { id: "emotion", label: "Emoční zralost partnera:",
        options: [["must","Nepostradatelná"],["important","Důležitá"],["growing","Stačí, že roste"]] },
      { id: "ambition_partner", label: "Ambice partnera:",
        options: [["high","Stejně ambiciózní jako já"],["balanced","Vyvážený"],["chill","V klidu, žije teď"],["any","Nezáleží"]] },
    ],
  },
  {
    key: "partner_lifestyle",
    title: "Životní styl partnera",
    subtitle: "Jak chceš, aby žil",
    icon: "🌟",
    group: "Hledám",
    questions: [
      { id: "partner_sport", label: "Partner a sport:",
        options: [["active","Aktivní, sportuje"],["sometimes","Občas se hýbe"],["nomatter","Nezáleží"]] },
      { id: "partner_alcohol", label: "Partner a alkohol:",
        options: [["sober","Nepije / zřídka"],["social","Sociálně OK"],["nomatter","Nezáleží"]] },
      { id: "partner_smoke", label: "Partner kuřák:",
        options: [["no","Absolutně ne"],["ok","Vadí, ale snesu"],["ok_yes","V pohodě"]] },
      { id: "partner_looks", label: "Jak důležitý je pro tebe vzhled?",
        options: [["important","Důležitý"],["chemistry","Hlavně chemie"],["personality","Hlavně osobnost"]] },
      { id: "partner_age_gap", label: "Věkový rozdíl partnera:",
        options: [["younger","Mladší"],["same","Podobný věk"],["older","Starší"],["any","Nezáleží"]] },
    ],
  },
  {
    key: "partner_values",
    title: "Hodnoty partnera",
    subtitle: "Hloubka a směr",
    icon: "💫",
    group: "Hledám",
    questions: [
      { id: "partner_top_value", label: "Co by mělo být pro partnera nejdůležitější?",
        options: [["family","Rodina"],["love","Láska/vztah"],["career","Kariéra"],["freedom","Svoboda"],["growth","Růst"],["faith","Víra"],["any","Nezáleží"]] },
      { id: "partner_children", label: "Partner a děti:",
        options: [["want","Musí chtít"],["open","Otevřený diskuzi"],["nokids","Bez dětí"],["any","Nezáleží"]] },
      { id: "partner_faith", label: "Víra partnera:",
        options: [["same","Stejná jako já"],["respect","Respekt k té mé"],["any","Nezáleží"]] },
      { id: "partner_education", label: "Vzdělání partnera:",
        options: [["high","Vysokoškolské+"],["medium","Středoškolské+"],["any","Nezáleží – hlavně chytrý"]] },
      { id: "partner_income", label: "Finanční stabilita partnera:",
        options: [["stable","Musí být stabilní"],["growing","Stačí, že roste"],["any","Nezáleží"]] },
    ],
  },
  {
    key: "dealbreakers",
    title: "Dealbreakery",
    subtitle: "Co absolutně NE",
    icon: "🚫",
    group: "Hledám",
    questions: [
      { id: "db_drugs", label: "Drogy:",
        options: [["never","Absolutní ne"],["soft_ok","Měkké občas OK"],["any","Neřeším"]] },
      { id: "db_lies", label: "Lhaní a manipulace:",
        options: [["never","Okamžitý konec"],["talk","Vyřešit a poučit"],["depends","Záleží"]] },
      { id: "db_debt", label: "Velké dluhy:",
        options: [["never","Stop"],["talk","Lze probrat"],["ok","Neřeším"]] },
      { id: "db_kids_existing", label: "Partner už má děti z předchozího vztahu:",
        options: [["ok","OK / vítáno"],["depends","Záleží na situaci"],["no","Raději ne"]] },
      { id: "db_distance", label: "Vzdálenost:",
        options: [["same_city","Stejné město"],["country","V Česku/SR"],["any","Nezáleží"]] },
    ],
  },
];

export const totalSections = QUESTIONNAIRE.length;
export const totalQuestions = QUESTIONNAIRE.reduce((s, sec) => s + sec.questions.length, 0);

// Helper - get all "self" keys vs "partner preference" keys for compat logic
export const SELF_KEYS = QUESTIONNAIRE.filter(s => s.group === "Já").map(s => s.key);
export const PREF_KEYS = QUESTIONNAIRE.filter(s => s.group === "Hledám").map(s => s.key);
